import React, { useEffect,useRef } from "react";
import { ReactComponent as VizIcon } from "../../../Icons/vizIcon.svg";
import SearchBar from "./SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { Upload, Input, Tag, Button } from "antd";
import { toast } from "react-toastify";
import { Actions } from "../../../Action";
import { bindActionCreators } from "redux";
import TooltipComp from "../../../NewComponent/ToolTip/TooltipComp";
import MultiSelectComp from "../../../NewComponent/MultiSelect/MultiSelect";
import { CloseCircleOutlined } from "@ant-design/icons";
import { getBase64 } from "../../../utils";

export default function BriefData() {
  const briefState = useSelector((state) => state.brief);
  const userState = useSelector((state) => state.user);
  const [accessToken, setValue] = React.useState(localStorage.getItem('accessToken'));
  const textRef = useRef(null);
  const dispatch = useDispatch();
  const {
    briefAgentTargetUrlChange,
    briefExternalSourceChange,
    briefInternalSourceChange,
    briefAttchmentChange
  } = bindActionCreators(Actions, dispatch);

  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const container1Styles = {
    width: `100%`,
    border: "1px solid #EAECF0",
    boxShadow: "0px 4px 16px 0px #1018280F",
    borderRadius: "12px",
    // minHeight: "400px",
    padding: "24px",
    marginBottom: "10px",
  };
  const textStyles = {
    fontSize: "20px",
    color: "#5C667B",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    // width:'100%',
    // cursor:'pointer',
  };
  const textStyles2 = {
    fontSize: "18px",
    color: "#5C667B",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    // width:'100%',
    // cursor:'pointer',
  };
  const textStyles3 = {
    fontSize: "16px",
    color: "#5C667B",
    lineHeight: "32px",
    fontWeight: "300",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    marginTop: "15px",
    minHeight: "200px",
    maxHeight: "500px",
    overflow: "auto",
    // width:'100%',
    // cursor:'pointer',
  };
  const getOrigText = (text, type) => {
    if (type === "i") {
      let orig = userState.agenticSources["Internal"].filter((dt) => {
        if (dt.value === text) {
          return dt;
        }
      });
      return orig[0].label;
    } else {
      let orig = userState.agenticSources["External"].filter((dt) => {
        if (dt.value === text) {
          return dt;
        }
      });
      return orig[0].label;
    }
  };
  const updateSources = (e, text, type) => {
    e.preventDefault();
    if (type === "i") {
      briefInternalSourceChange(
        briefState.internalSources.filter((item) => item !== text)
      );
    } else {
      briefExternalSourceChange(
        briefState.externalSources.filter((item) => item !== text)
      );
    }
  };
  const updatelinks = (e, text) => {
    e.preventDefault();
    briefAgentTargetUrlChange(
      briefState.links
        .split(",")
        .filter((item) => item !== text)
        .join(",")
    );
  };
  const updateAttachment=async(file)=>{
    if(briefState.files.length>=3){
      toast.error(successfulHelpful("Maximum 3 files allowed!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    briefAttchmentChange([...briefState.files,file]);
  }
  const popup = () => {
   
      return (
        <div style={{textAlign:'center'}}>
          <div style={{display:'flex',alignItems:'center'}}>
            <div style={{width:'100px',fontSize:'16px'}}>Internal:</div>
          <div style={{ padding: "10px" }}>
            <MultiSelectComp
              size={"large"}
              value={briefState.internalSources}
              onChangeFunc={briefInternalSourceChange}
              placeholder={"Select Sources"}
              width={"200px"}
              options={userState.agenticSources["Internal"]}
            />
          </div>
          </div>
      
   
        
          {userState.agenticSources["External"] !== undefined && <div style={{display:'flex',alignItems:'center'}}>
            <div style={{width:'100px',fontSize:'16px'}}>External:</div>
          <div style={{ padding: "10px" }}>
            <MultiSelectComp
              size={"large"}
              placeholder={"Select Sources"}
              onChangeFunc={briefExternalSourceChange}
              width={"200px"}
              value={briefState.externalSources}
              options={userState.agenticSources["External"]}
            />
          </div>
          </div>}
       
          {briefState.externalSources.includes("targeturl") &&<div style={{display:'flex',alignItems:'center'}}>
            <div style={{width:'100px',fontSize:'16px'}}>Add Links:</div>
          <div style={{ padding: "10px" }}>
            <div style={{ width: "200px" }}>
              <Input
                size="large"
                placeholder="Paste or enter urls..."
                value={briefState.links}
                onChange={(e) => briefAgentTargetUrlChange(e.target.value)}
              />
              <br />
            </div>
          </div>
          </div>}
          {/* <div style={{display:'flex',alignItems:"baseline"}}>
            <div style={{width:'100px',fontSize:'16px'}}>Attachments:</div>
          <div style={{ padding: "10px" }}>
            <div style={{ width: "200px", textAlign: "start" }}>
              <Upload name="file" fileList={[]} onChange={e=>updateAttachment(e.file.originFileObj)} accept=".pdf">
    <Button style={{color:'#5C667B'}}>Click to Add</Button>
  </Upload>
              <br />
            </div>
          </div>
          </div> */}
        </div>
      )
  };
  const copyToClipboard = () => {
    // console.log("hello");
    if (textRef.current) {
      const range = document.createRange();
      range.selectNodeContents(textRef.current);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand("copy"); // Copies as rich text

      selection.removeAllRanges(); // Clear selection
      toast.success(successfulHelpful("Brief copied!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const textStyles4 = {
    fontSize: "16px",
    color: "#5C667B",
    lineHeight: "32px",
    fontWeight: "300",
    width: "70px",
    // cursor:'pointer',
  };
const removeFile = (e, file) => {
  e.preventDefault();
  briefAttchmentChange(briefState.files.filter((f) => f.name !== file.name));
}
  const getToken = () => {
    const logoutTab = window.open(userState.showpadLogoutUrl, "_blank");
    setTimeout(() => {
    if (logoutTab){
      logoutTab.close();
      window.open(userState.showpadAppUrl,"_blank")
    }
  }, 3000);
  }
  useEffect(() => {
      const interval = setInterval(() => {
        const newValue = localStorage.getItem('accessToken');
        if (newValue !== accessToken) {
          setValue(newValue); // update state if localStorage value changed
        }
      }, 1000); // check every 1 second (or use a shorter delay if needed)
  
      return () => clearInterval(interval);
    }, [accessToken]);
  return (
    <>
      {/* {briefState.phase !== 2 && (
        <div style={container1Styles}>
          <div
            style={{ display: "flex", alignItems: "center", height: "25px" }}
          >
            <span>
              <VizIcon />
            </span>
            &nbsp;<span style={textStyles2}>Vizerto</span>&nbsp;
            <span style={textStyles}>Briefing Agent</span>
          </div>
          <div
            style={{
              background:
                "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
              width: "100%",
              height: "1px",
              margin: "15px 0",
            }}
          ></div>
          {briefState.response.length === 0 && !briefState.isLoading && (
            <div style={textStyles3}>
              <div>Hello, {userState.firstName}!</div>
              <div>I’m here to help.</div>
              <div>
                What information or details would be most useful for a briefing
                on a specific topic?{" "}
              </div>
              <div>
                I can provide insights on products, features, and
                company-specific information based on what I’ve learned.
              </div>
            </div>
          )}
          {briefState.response.length !== 0 && !briefState.isLoading && (
            <div
              style={textStyles3}
              ref={textRef}
              dangerouslySetInnerHTML={{ __html: briefState.response }}
            ></div>
          )}
          {briefState.isLoading && (
            <div style={textStyles3}>
              {briefState.phase === 1 &&
                "Planning the steps to prepare your briefing. This may take a few minutes..."}
              {briefState.phase === 3 && (
                <>
                  <div>
                    Going through the steps of researching, summarizing, and
                    compiling the final brief. This may take a few minutes...
                  </div>
                  <div>
                    You will be notified by email once the brief is ready. You
                    can then review it under{" "}
                    <span style={{ fontWeight: "500" }}>
                      Seeker → Saved Briefs
                    </span>
                    .
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )} */}
      <div style={{ paddingInline: "22px",paddingBlock:'10px' }}>
        {userState.agenticSources !== undefined && userState.agenticSources['Internal'] !== undefined &&<div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <TooltipComp title={popup()}>
                <i
                  style={{ fontSize: "24px", color: "#5C667B", cursor: "pointer" }}
                  className="fa fa-plus-circle"
                ></i>
              </TooltipComp>
            </div>
            &nbsp;&nbsp;
            <div style={{display:'flex', alignItems:'center',flexWrap:'wrap',gap:'5px'}}>
              {briefState.internalSources.length > 0 &&
                briefState.internalSources.map((dt, i) => {
                  return (
                    <Tag
                      key={i}
                      style={{ color: "#5C667B" }}
                      closeIcon={
                        <CloseCircleOutlined
                          onClick={(e) => updateSources(e, dt, "i")}
                        />
                      }
                    >
                      {getOrigText(dt, "i")}
                    </Tag>
                  );
                })}
                {briefState.externalSources.length > 0 &&
                briefState.externalSources.map((dt, i) => {
                  if (dt !== "Showpad") {
                    return (
                      <Tag
                        key={i}
                        style={{ color: "#5C667B" }}
                        closeIcon={<CloseCircleOutlined onClick={(e) => updateSources(e, dt, "e")} />}
                      >
                        {getOrigText(dt, "e")}
                      </Tag>
                    );
                  }
                  if (dt === "Showpad") {
                    return (
                      <>
                     { accessToken !== null &&<Tag
                        key={i}
                        color="#00A3FF"
                        closeIcon={<CloseCircleOutlined style={{color:'white'}} onClick={(e) => updateSources(e, dt, "e")} />}
                        
                      >
                        <span>{getOrigText(dt, "e")} (connected)</span>
                      </Tag>}
                      {accessToken === null &&<Tag
                        key={i}
                        color="#F59B00"
                        closeIcon={<CloseCircleOutlined style={{color:'white'}} onClick={(e) => updateSources(e, dt, "e")} />}
                      >
                        <span style={{cursor:'pointer'}} onClick={()=>getToken()}>{getOrigText(dt, "e")} (click to connect)</span>
                      </Tag>}
                      </>
                    );
                  }
                })}
                {briefState.externalSources.includes("targeturl") && (
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {briefState.links.length > 0 &&
                  briefState.links.split(",").map((dt, i) => {
                    return (
                      <Tag
                        key={i}
                        style={{ color: "#5C667B" }}
                        closeIcon={
                          <CloseCircleOutlined
                            onClick={(e) => updatelinks(e, dt)}
                          />
                        }
                      >
                        {dt}
                      </Tag>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
        {briefState.files.length > 0 && (
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {
                  briefState.files.map((dt, i) => {
                    return (
                      <Tag
                        key={i}
                        style={{ color: "#5C667B" }}
                        closeIcon={
                          <CloseCircleOutlined
                            onClick={(e) => removeFile(e, dt)}
                          />
                        }
                      >
                        {dt.name}
                      </Tag>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
            </div>
          </div>
        </div>}
        
        
        {/* {userState.agenticSources !== undefined && userState.agenticSources['External'] !== undefined &&<div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={textStyles4}>External:</div>
            <div>
              <TooltipComp title={popup("external")}>
                <i
                  style={{ fontSize: "16px", color: "#5C667B" }}
                  className="fa fa-plus-circle"
                ></i>
              </TooltipComp>
            </div>
            &nbsp;&nbsp;
            <div>
              {briefState.externalSources.length > 0 &&
                briefState.externalSources.map((dt, i) => {
                  if (dt !== "Showpad") {
                    return (
                      <Tag
                        key={i}
                        style={{ color: "#5C667B" }}
                        closeIcon={<CloseCircleOutlined onClick={(e) => updateSources(e, dt, "e")} />}
                      >
                        {getOrigText(dt, "e")}
                      </Tag>
                    );
                  }
                  if (dt === "Showpad") {
                    return (
                      <>
                     { accessToken !== null &&<Tag
                        key={i}
                        color="#00A3FF"
                        closeIcon={<CloseCircleOutlined style={{color:'white'}} onClick={(e) => updateSources(e, dt, "e")} />}
                        
                      >
                        <span>{getOrigText(dt, "e")} (connected)</span>
                      </Tag>}
                      {accessToken === null &&<Tag
                        key={i}
                        color="#F59B00"
                        closeIcon={<CloseCircleOutlined style={{color:'white'}} onClick={(e) => updateSources(e, dt, "e")} />}
                      >
                        <span style={{cursor:'pointer'}} onClick={()=>window.open(userState.showpadAppUrl,"_blank")}>{getOrigText(dt, "e")} (click to connect)</span>
                      </Tag>}
                      </>
                    );
                  }
                })}
            </div>
          </div>
        </div>} */}
        
      </div>
    </>
  );
}
